import { IntlShape } from "react-intl";
import { TableColumns } from "../shared/crud/list";
import { UpgradeConfigurationEntity } from "./domain/upgradeConfiguration.entity";
import {
  SellingLocationEnum,
  NotificationChannelEnum,
  UpgradeTarget,
} from "./domain/upgradeConfiguration.schema";
import { BooleanRenderer, mapRenderer, StringRenderer } from "../shared/renderers/table";
import { tableHeaderMessages } from "./upgradeManager.messages";
import { formatDateRanges, formatDelta } from "./utils/formatters";

export type UpgradeConfigurationTableRow = {
  id: string;
  active: boolean;
  sellingLocations: SellingLocationEnum[];
  notificationChannels: NotificationChannelEnum[];
  minReleaseInDays: number | undefined;
  maxReleaseInDays: number;
  minDelta: string;
  maxDelta: string;
  sellingTargets: UpgradeTarget[];
  includedDates: string;
  excludedDates: string;
};

export function entityToTableRow(entity: UpgradeConfigurationEntity): UpgradeConfigurationTableRow {
  const rule = entity.generalSellingActivationRule;
  return {
    id: entity.id,
    active: entity.active,
    sellingLocations: entity.sellingLocations,
    notificationChannels: entity.notificationChannels,
    minReleaseInDays: rule.minReleaseInDays,
    maxReleaseInDays: rule.maxReleaseInDays,
    minDelta: rule.minAmountDelta ? formatDelta(rule.minAmountDelta) : "-",
    maxDelta: rule.maxAmountDelta ? formatDelta(rule.maxAmountDelta) : "-",
    sellingTargets: entity.sellingTargets,
    includedDates: formatDateRanges(rule.includedDates),
    excludedDates: formatDateRanges(rule.excludedDates),
  };
}

export default function getTableColumns(
  intl: IntlShape
): TableColumns<UpgradeConfigurationTableRow> {
  return {
    active: {
      renderer: BooleanRenderer,
    },
    id: {
      renderer: StringRenderer,
    },
    sellingLocations: {
      renderer: mapRenderer(StringRenderer, v => v?.join(", ") || ""),
    },
    notificationChannels: {
      renderer: mapRenderer(StringRenderer, v => v?.join(", ") || ""),
    },
    minReleaseInDays: {
      renderer: mapRenderer(StringRenderer, v => v?.toString() ?? "-"),
    },
    maxReleaseInDays: {
      renderer: mapRenderer(StringRenderer, v => v?.toString() ?? "-"),
    },
    minDelta: {
      renderer: StringRenderer,
    },
    maxDelta: {
      renderer: StringRenderer,
    },
    sellingTargets: {
      renderer: mapRenderer(StringRenderer, v => {
        if (!v || v.length === 0) return "-";
        if (v.length === 1) return v[0].targetType;
        return intl.formatMessage(tableHeaderMessages.multiple);
      }),
    },
    includedDates: {
      renderer: StringRenderer,
    },
    excludedDates: {
      renderer: StringRenderer,
    },
  };
}
